import { useCopilotAction } from '@copilotkit/react-core'

/**
 * Persist a key/value pair in `window.localStorage`.
 */
export const useSetLocalStorageAction = () => {
  useCopilotAction({
    name: 'setLocalStorage',
    available: 'remote',
    description:
      'Set a value in the local storage. Use when the user asks to set a value in the local storage.',
    parameters: [
      {
        name: 'key',
        description: 'The key to set in the local storage.',
        required: true,
      },
      {
        name: 'value',
        description: 'The value to set in the local storage.',
        required: true,
      },
    ],
    followUp: false,
    handler: async ({ key, value }) => {
      localStorage.setItem(key, value)
    },
  })
}
